module.exports = __webpack_public_path__ + "img/widgets1.bf1d37cc.png";